import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/faq", label: "FAQ" },
  { to: "/privacy", label: "Privacy" },
  { to: "/support", label: "Support" },
];

export const Navbar = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-white/70 backdrop-blur-xl border-b border-ink/10"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-display font-black text-2xl tracking-tighter text-ink"
        >
          save<span className="text-brand text-glow-brand">u</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              data-active={pathname === item.to}
              className="nav-link font-body text-sm uppercase tracking-widest text-ink/70 hover:text-ink transition-colors"
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/support"
            data-testid="nav-cta"
            className="glow-ring bg-brand text-white font-body font-semibold text-sm uppercase tracking-wider px-6 py-3 rounded-full hover:-translate-y-0.5 transition-transform"
          >
            Get Help
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-ink p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-white/95 backdrop-blur-xl border-t border-ink/10 px-6 py-8 flex flex-col gap-6"
        >
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`nav-mobile-link-${item.label.toLowerCase()}`}
              className="font-display uppercase text-xl tracking-tight text-ink"
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
